export interface GridLayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minH?: number;
  minW?: number;
  moduleId?: number;
}

interface WidgetLayoutItem {
  key: string;
  layout: {
    lg: {
      x: number;
      y: number;
      width: number;
      height: number;
      minH?: number;
      minW?: number;
    };
  };
  [key: string]: any;
}

export function calculateUpdatedLayout(
  widgetLayoutItem: WidgetLayoutItem[],
  chartDataCounts?: { withData: number; withoutData: number },
): WidgetLayoutItem[] {
  const HEIGHT_STACKED_BASE_WITH_DATA = 4.75; //chart with legend
  const HEIGHT_COV_BASE_WITH_DATA = 4.34; //chart with out legend + margin top

  const HEIGHT_STACKED_INCREMENT = 4.5; //header + edit y axis button
  const HEIGHT_COV_INCREMENT = 2.5; //header

  const HEIGHT_DEFAULT_WIDGETS = 18;

  const HEIGHT_STACKED_INCREMENT_NO_DATA = 1.75; //no data stacked height
  const HEIGHT_COV_INCREMENT_NO_DATA = 1.78; //no data cov height

  const HEIGHT_FOR_NO_DATA = 10;

  const originalTimeseries = widgetLayoutItem?.find((w) => w.key === 'timeseriesChart');
  if (!originalTimeseries || !originalTimeseries.layout?.lg) return widgetLayoutItem;

  const chartType = originalTimeseries?.widgetProperty?.widgetProperties?.chartType;

  if (!chartType) {
    console.log('Chart type is not defined for timeseriesChart widget');
    return widgetLayoutItem;
  }

  let newHeight = 0;
  if (chartType?.toLowerCase() === 'stacked' || chartType?.toLowerCase() === 'cov') {
    const visibleCount =
      originalTimeseries.widgetProperty?.widgetProperties?.parameterConfig?.[0]?.parameters?.filter(
        (param: { description: string; selected: boolean }) => param.selected === true,
      )?.length || 0;
    if (visibleCount === 0) {
      return widgetLayoutItem;
    }

    const withData = chartDataCounts?.withData ?? 0;
    const withoutData = chartDataCounts?.withoutData ?? 0;

    const timeSeriesHeaderHeight = chartType?.toLowerCase() === 'cov' ? HEIGHT_COV_INCREMENT : HEIGHT_STACKED_INCREMENT;
    const withDataHeight =
      chartType?.toLowerCase() === 'cov' ? HEIGHT_COV_BASE_WITH_DATA : HEIGHT_STACKED_BASE_WITH_DATA;
    const withoutDataHeight =
      chartType?.toLowerCase() === 'cov' ? HEIGHT_COV_INCREMENT_NO_DATA : HEIGHT_STACKED_INCREMENT_NO_DATA;

    //0.25 for 8 px gap between header and chart and between charts, which is 1 unit in grid layout
    newHeight =
      timeSeriesHeaderHeight + (visibleCount - 2) * 0.25 + withData * withDataHeight + withoutData * withoutDataHeight;

    if ((withData === 0 && withoutData === 0) || newHeight < HEIGHT_FOR_NO_DATA) {
      newHeight = HEIGHT_FOR_NO_DATA;
    }
  } else {
    newHeight = HEIGHT_DEFAULT_WIDGETS;
  }

  const oldHeight = originalTimeseries.layout.lg.height;
  const heightDelta = newHeight - oldHeight;

  const newwidgetLayoutItem = widgetLayoutItem.map((widget) => {
    const updatedWidget = { ...widget, layout: { ...widget.layout, lg: { ...widget.layout.lg } } };

    if (widget.key === 'timeseriesChart') {
      updatedWidget.layout.lg.height = newHeight;
    } else if (widget.layout.lg.y > originalTimeseries.layout.lg.y) {
      updatedWidget.layout.lg.y += heightDelta;
    }

    return updatedWidget;
  });

  console.log('Updated widget layout:', newwidgetLayoutItem);
  return newwidgetLayoutItem;
}

export function filterWidgetItemnsForTestScreen(
  widgetLayoutItem: WidgetLayoutItem[],
  layout: string,
): WidgetLayoutItem[] {
  if (layout?.toLowerCase() === 'all') {
    return widgetLayoutItem?.filter((item) => item.key !== 'wellTestSplitChart');
  } else if (layout?.toLowerCase() === 'split') {
    return widgetLayoutItem?.filter((item) => item.key !== 'wellTestChart');
  }
  return widgetLayoutItem;
}

export function filterWidgetItemsForRecommendationScreen(
  widgetLayoutItem: WidgetLayoutItem[],
  activeTab: string,
): WidgetLayoutItem[] {
  if (!widgetLayoutItem || !Array.isArray(widgetLayoutItem)) {
    return [];
  }

  return widgetLayoutItem.filter((item) => {
    if (!item?.key) return false;

    const itemKey = item.key.toLowerCase();
    const tab = activeTab.toLowerCase();

    if (tab === 'esp') {
      return itemKey.includes('esp');
    }

    if (tab === 'gl') {
      return itemKey.includes('gl');
    }

    // Default: show all widgets if tab is not recognized
    return true;
  });
}
